import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../../utils/validate-payload.js';
import { querySetDefinition, } from '../../query-set/query-set-actions.js';
export const registerQuerySetQuery = createAction('commerce/querySet/register', (payload) => validatePayload(payload, querySetDefinition));
export const updateQuerySetQuery = createAction('commerce/querySet/update', (payload) => validatePayload(payload, querySetDefinition));
